import { boolean, defineAction, object } from '~/prix'
import legalEntityAttendanceFetchAction from './legalEntityAttendanceFetch.action.json' with { type: 'json' }

const legalEntityAttendanceFetchActionDefinition = defineAction({
  ...legalEntityAttendanceFetchAction,
  input: object({}),
  output: object({
    ok: boolean(),
  }),
})

export default legalEntityAttendanceFetchActionDefinition
